<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="用户">
<!--                  <el-input  v-model="queryForm.userId"></el-input>-->
                  <GridSelectU style="width: 177px;" labelName="userName"
                               labelValue="id" title="选择用户" :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户'
                               @getValue="getSearchValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
<!--              <el-form-item label="考试类型：1exam 2test">-->
<!--                  <el-input  v-model="queryForm.examType"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="试卷或测试ID">-->
<!--                  <el-input  v-model="queryForm.typeId"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="总得分">-->
<!--                  <el-input  v-model="queryForm.score"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="已批改（所有题目都被批改后）">-->
<!--                  <el-input  v-model="queryForm.isCorrected"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getEduExerciseExamList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
<!--        <el-button-->
<!--          type="primary"-->
<!--          size="small"-->
<!--          icon="el-icon-plus"-->
<!--          @click="addEduExerciseExam"-->
<!--        >新建</el-button>-->
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editEduExerciseExam(null)"-->
<!--        >修改</el-button>-->
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteEduExerciseExam(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshEduExerciseExamList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="eduExerciseExamList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if="scope.row.user">
                  <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                  <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                  <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                  <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="examType"
        label="考试类型"
        width="180"
      >
          <template slot-scope="scope">
              {{ scope.row.examType == 1 ? '考试' : '测试' }}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="typeId"
        label="试卷或测试ID"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="score"
        label="总得分"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="isCorrected"
        label="已批改（所有题目都被批改后）"
        width="180"
      >
          <template slot-scope="scope">
              {{ scope.row.isCorrected == 1 ? '已批改' : '未批改' }}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
<!--            <div @click="checkEduExerciseExam(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Eye24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">查看</span>-->
<!--            </div>-->
              <div @click="addRecord(scop.row)">
                  <Icon size="16">
                      <Eye24Regular />
                  </Icon>
                  <span class="operation-label">查看</span>
              </div>
<!--            <div @click="editEduExerciseExam(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
            <div @click="deleteEduExerciseExam(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="eduExerciseExamStates[eduExerciseExamState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
      :append-to-body="true"
    >
      <div>
        <el-form
          :model="eduExerciseExam"
          ref="eduExerciseExamForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="用户"
            prop="userId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduExerciseExam.userId"-->
<!--              :disabled="eduExerciseExamState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" labelName="userName"
                           labelValue="id" title="选择用户" :value="eduExerciseExam.userId" :limit='1' size='small' placeholder='请选择用户' :disabled="eduExerciseExamState == 'check'"
                           @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
          </el-form-item>
<!--          <el-form-item-->
<!--            label="考试类型：1exam 2test"-->
<!--            prop="examType"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduExerciseExam.examType"-->
<!--              :disabled="eduExerciseExamState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item-->
<!--            label="试卷或测试ID"-->
<!--            prop="typeId"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduExerciseExam.typeId"-->
<!--              :disabled="eduExerciseExamState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
          <el-form-item
            label="总得分"
            prop="score"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="eduExerciseExam.score"
              :disabled="eduExerciseExamState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="已批改"
            prop="isCorrected"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduExerciseExam.isCorrected"-->
<!--              :disabled="eduExerciseExamState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                size="small"
                style="width: 177px;"
                v-model="eduExerciseExam.isCorrected"
                :disabled="eduExerciseExamState == 'check'"
              >
                <el-option
                  label="已批改"
                  :value="1"
                ></el-option>
                  <el-option
                      label="未批改"
                      :value="0"
                  ></el-option>
              </el-select>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="eduExerciseExamState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
      <!--      测试分析-->
      <el-dialog
          title="分析详情"
          :visible.sync="showRecordDialog"
          width="60%"
          @close="closeRecordDialog"
          :append-to-body="true"
      >
          <EduRecord style="height: 500px" ref="record"></EduRecord>
          <div
              slot="footer"
              class="flex justify-end"
          >
              <el-button @click="closeRecordDialog">关闭</el-button>
          </div>
      </el-dialog>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';
import EduExerciseExamAnalysis from '@/components/edu/EduExerciseExamAnalysis.vue';
import EduExerciseExamRecord from '@/components/edu/EduExerciseExamRecord.vue';
import EduRecord from '@/components/edu/EduRecord.vue';

export default {
    components: {
        EduRecord,
        EduExerciseExamRecord,
        EduExerciseExamAnalysis,
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetEduExerciseExamList();
                    this.getEduExerciseExamList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetEduExerciseExamList();
                    this.getEduExerciseExamList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     userId: '', //用户
                     examType: '', //考试类型：1exam 2test
                     typeId: '', //试卷或测试ID
                     score: '', //总得分
                     isCorrected: '', //已批改（所有题目都被批改后）
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                eduExerciseExamState: 'add',
                eduExerciseExamStates: {
                    add: '添加记录',
                    check: '查看记录',
                    edit: '修改记录'
                },

                multipleSelection: [],
                eduExerciseExamList: [],
                eduExerciseExam: {
                    id: '', //
                    userId: '', //用户
                    examType: '', //考试类型：1exam 2test
                    typeId: '', //试卷或测试ID
                    score: '', //总得分
                    isCorrected: '', //已批改（所有题目都被批改后）
                },
                btnLoading: false,
                USER_code: USER,
                USER_search: USER_SEARCH,
                rules: {
                    id: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                    examType: [{ required: true, message: '考试类型不能为空', trigger: 'blur' }],
                    typeId: [{ required: true, message: '试卷或测试ID不能为空', trigger: 'blur' }],
                    score: [{ required: true, message: '总得分不能为空', trigger: 'blur' }],
                    isCorrected: [{ required: true, message: '已批改（所有题目都被批改后）不能为空', trigger: 'blur' }],
                },
                showRecordDialog: false
            };
        },
        created() {

        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            addRecord(item){
                this.showRecordDialog = true;
                this.$nextTick(()=>{
                    this.$refs.record.init(item);
                })
            },
            closeRecordDialog(){
                this.showRecordDialog = false;
            },
            getValueUser(value){
                this.eduExerciseExam.userId = value
            },
            getSearchValueUser(value){
                this.queryForm.userId = value
            },
            init(id, sign){
                this.queryForm.examType = sign;
                this.queryForm.typeId = id;
                this.eduExerciseExam.examType = sign;
                this.eduExerciseExam.typeId = id;
                this.getEduExerciseExamList();
            },
            resetEduExerciseExamList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.eduExerciseExamList = [];
            },
            resetDialog() {
                this.eduExerciseExamState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      userId: '', //用户
                      examType: this.queryForm.examType, //考试类型：1exam 2test
                      typeId: this.queryForm.typeId, //试卷或测试ID
                      score: '', //总得分
                      isCorrected: '', //已批改（所有题目都被批改后）
                };
                this.getEduExerciseExamList();
            },
            closeDialog() {
                this.showDialog = false
                this.eduExerciseExam = {
                      id: '', //
                      userId: '', //用户
                      examType: this.eduExerciseExam.examType, //考试类型：1exam 2test
                      typeId: this.eduExerciseExam.typeId, //试卷或测试ID
                      score: '', //总得分
                      isCorrected: '', //已批改（所有题目都被批改后）
                };
            },
            submitForm() {
                if (this.eduExerciseExamState == 'add') {
                    this.$refs.eduExerciseExamForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/exerciseexam/add`,{ ...this.eduExerciseExam }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetEduExerciseExamList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.eduExerciseExamState == 'edit') {
                    this.$refs.eduExerciseExamForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/exerciseexam/edit`,{ ...this.eduExerciseExam }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetEduExerciseExamList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addEduExerciseExam() {
                this.showDialog = true;
                this.eduExerciseExamState = 'add';
            },
            checkEduExerciseExam(eduExerciseExamId) {
                console.log(eduExerciseExamId);
                this.currentEduExerciseExamId = eduExerciseExamId;

                this.getEduExerciseExamById();
                this.showDialog = true;
                this.eduExerciseExamState = 'check';
            },
            editEduExerciseExam(eduExerciseExamId) {
                console.log('eduExerciseExam', eduExerciseExamId);
                if (eduExerciseExamId) {
                    this.currentEduExerciseExamId = eduExerciseExamId;
                    this.getEduExerciseExamById();
                } else {
                    this.eduExerciseExam = { ...this.eduExerciseExam, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.eduExerciseExamState = 'edit';
            },
            deleteEduExerciseExam(eduExerciseExamId) {
                let ids = '';
                if (eduExerciseExamId) {
                    ids = eduExerciseExamId;
                } else {
                    ids = this.multipleSelection.map((eduExerciseExam) => eduExerciseExam.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/edu/exerciseexam/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetEduExerciseExamList();
                                this.getEduExerciseExamList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshEduExerciseExamList() {
                this.resetEduExerciseExamList();
                this.getEduExerciseExamList();
            },
            getEduExerciseExamList(query = {}) {
                this.loading = true;
                get(`/edu/exerciseexam/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.eduExerciseExamList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getEduExerciseExamById() {
                get(`/edu/exerciseexam/get`,{ id: this.currentEduExerciseExamId }).then((res) =>{
                    if(res.success){
                      this.eduExerciseExam = { ...this.eduExerciseExam, ...res.eduExerciseExam };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportEduExerciseExamList() {
                //this.btnLoading = true;
                exprotExcel(`/edu/exerciseexam/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/edu/exerciseexam/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/edu/exerciseexam/importData`,formData);
              this.refreshEduExerciseExamList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getEduExerciseExamList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getEduExerciseExamList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>